export default "__VITE_ASSET__DBOCCEPu__"